var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscountAmount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#2D2042",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 16.2499C16.8099 16.2499 16.6199 16.1799 16.4699 16.0299L14.4999 14.0599L12.5299 16.0299C12.2399 16.3199 11.7599 16.3199 11.4699 16.0299C11.1799 15.7399 11.1799 15.2599 11.4699 14.9699L13.9699 12.4699C14.2599 12.1799 14.7399 12.1799 15.0299 12.4699L17.5299 14.9699C17.8199 15.2599 17.8199 15.7399 17.5299 16.0299C17.3799 16.1799 17.1899 16.2499 16.9999 16.2499Z",
    fill: "#2D2042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 27.75C14.09 27.75 13.75 27.41 13.75 27V13C13.75 12.59 14.09 12.25 14.5 12.25C14.91 12.25 15.25 12.59 15.25 13V27C15.25 27.41 14.91 27.75 14.5 27.75ZM28 16.25H20C19.59 16.25 19.25 15.91 19.25 15.5C19.25 15.09 19.59 14.75 20 14.75H28C28.41 14.75 28.75 15.09 28.75 15.5C28.75 15.91 28.41 16.25 28 16.25ZM24 22.25H20C19.59 22.25 19.25 21.91 19.25 21.5C19.25 21.09 19.59 20.75 20 20.75H24C24.41 20.75 24.75 21.09 24.75 21.5C24.75 21.91 24.41 22.25 24 22.25ZM22 25.25H20C19.59 25.25 19.25 24.91 19.25 24.5C19.25 24.09 19.59 23.75 20 23.75H22C22.41 23.75 22.75 24.09 22.75 24.5C22.75 24.91 22.41 25.25 22 25.25ZM26 19.25H20C19.59 19.25 19.25 18.91 19.25 18.5C19.25 18.09 19.59 17.75 20 17.75H26C26.41 17.75 26.75 18.09 26.75 18.5C26.75 18.91 26.41 19.25 26 19.25Z",
    fill: "#2D2042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountAmount);
export default __webpack_public_path__ + "static/media/discount-amount.374102c7deeed0f4da8961e19ac7f3de.svg";
export { ForwardRef as ReactComponent };